module.exports = __webpack_public_path__ + "static/media/galerija_2017 (19).3392c306.jpg";